import { get, last } from 'lodash'
import { connect } from 'react-redux'
import actions from '../../actions/LargeGroupCustomBenefitsSets'
import historyActions from '../../actions/BenefitsSetFieldHistories'
import BenefitsSetShow from '../BenefitsSet/BenefitsSetShow'
import LargeGroupCustomBenefitsSetComponent from './LargeGroupCustomBenefitsSetComponent'

const mapStateToProps = (state) => {
  const slice = state.largeGroupCustomBenefitsSets.show

  const configuration = state.login.session.configuration.large_group_custom_benefits
  const historySlice = state.benefitsSetFieldHistory.index
  return {
    benefitsSet: slice.attributes,
    rejection: last(get(slice.attributes, 'rejections', [])),
    configuration,
    benefitsSetFieldHistory: historySlice.records,
    productLine: 'Large Group Custom',
    benefitsSetComponent: LargeGroupCustomBenefitsSetComponent
  }
}

const mapDispatchToProps = {
  show: actions.show.main,
  reset: actions.show.reset,
  history: historyActions.index.main,
  resetHistory: historyActions.index.reset
}

export default connect(mapStateToProps, mapDispatchToProps)(BenefitsSetShow)
